import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO';
import { FadeInUp } from '../components/Animations';

export default function Services() {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';
  const services = t('servicesPage.services', { returnObjects: true });
  const whyItems = t('servicesPage.whyItems', { returnObjects: true });

  return (
    <>
      <SEO
        title={isRTL ? 'وجود لينك | الخدمات' : 'Wojod Link | Services'}
        description={t('servicesPage.description')}
      />

      {/* ── Page Hero ── */}
      <section className="page-hero">
        <div className="container">
          <FadeInUp>
            <div className="page-hero-content">
              <span className="section-label">{t('servicesPage.label')}</span>
              <h1 className="page-title">{t('servicesPage.title')}</h1>
              <p className="page-description">{t('servicesPage.description')}</p>
            </div>
          </FadeInUp>
        </div>
      </section>

      {/* ── Service Detail Cards ── */}
      <section className="services-detail">
        <div className="container">
          <div className="services-detail-grid">
            {services.map((svc, i) => (
              <FadeInUp key={i} delay={i * 0.08}>
                <div className="service-detail-card">
                  <div className="service-detail-icon">
                    <i className={svc.icon} />
                  </div>
                  <h3 className="service-detail-title">{svc.title}</h3>
                  <p className="service-detail-description">{svc.desc}</p>
                  <ul className="service-features">
                    {svc.features.map((feat, fi) => (
                      <li key={fi}>
                        <i className="fas fa-check-circle" />
                        <span>{feat}</span>
                      </li>
                    ))}
                  </ul>
                  <Link to="/contact" className="btn btn-outline btn-block">
                    {t('servicesPage.requestService')}
                  </Link>
                </div>
              </FadeInUp>
            ))}
          </div>
        </div>
      </section>

      {/* ── Why Choose Us ── */}
      <section className="why-choose-us">
        <div className="container">
          <FadeInUp>
            <div className="section-header text-center">
              <span className="section-label">{t('servicesPage.whyLabel')}</span>
              <h2 className="section-title">{t('servicesPage.whyTitle')}</h2>
              <p className="section-description">{t('servicesPage.whyDescription')}</p>
            </div>
          </FadeInUp>

          <div className="why-grid">
            {whyItems.map((item, i) => (
              <FadeInUp key={i} delay={i * 0.1}>
                <div className="why-card">
                  <div className="why-number">{item.num}</div>
                  <h3 className="why-title">{item.title}</h3>
                  <p className="why-text">{item.text}</p>
                </div>
              </FadeInUp>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section className="cta-section">
        <div className="container">
          <FadeInUp>
            <div className="cta-content">
              <h2>{t('servicesPage.ctaTitle')}</h2>
              <p>{t('servicesPage.ctaDescription')}</p>
              <div className="cta-buttons">
                <Link to="/contact" className="btn btn-accent">
                  {t('servicesPage.ctaBtn')} <i className={`fas fa-arrow-${isRTL ? 'left' : 'right'}`} />
                </Link>
              </div>
            </div>
          </FadeInUp>
        </div>
      </section>
    </>
  );
}
